<template>
    <button @click.stop="visitSavedOutfits" class="footer-button">
        <svg width="21px" height="20px" viewBox="0 0 21 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Search-/-Explore" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <g id="Main---New-Nav" transform="translate(-259.000000, -747.000000)" stroke="#000000" stroke-width="1.2">
                    <g id="Group-2" transform="translate(260.000000, 748.000000)">
                        <path d="M9.6,16.8 L1.41822182,8.26133739 C-0.0551915972,6.78793413 -0.42061527,4.5375763 0.510913344,2.67393603 L0.510913344,2.67393603 C1.20767886,1.28309507 2.53046399,0.311558573 4.06646056,0.062518773 C5.60245713,-0.186521027 7.16462121,0.317262366 8.26544045,1.41665075 L9.6,2.75391601 L10.9361597,1.41825035 C12.0366706,0.318847533 13.5986275,-0.184967309 15.1344107,0.0640892899 C16.6701939,0.313145889 17.992709,1.28473299 18.6890867,2.67553563 L18.6890867,2.67553563 C19.6206153,4.5391759 19.2551916,6.78953373 17.7817782,8.26293699 L9.6,16.8 Z" id="Path"></path>
                    </g>
                </g>
            </g>
        </svg>
        <span>Outfit</span>
    </button>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
        },
        methods: {
            visitSavedOutfits(){
                this.$router.push({path: '/saved-outfits'});
                this.$emit('click');
            },
        }
    }
</script>
